import React from 'react';
import Utils from 'commons/utils';
import { Button } from '@mui/material';
import { SearchInputColumn, DatePickerSearchColumn, SelectionSearchColumn } from 'components';
import {
  QUOTE_PRICE_STATUS_OPTIONS_COLUMN,
  QUOTE_PRICE_STATUS_OPTIONS_ALL,
} from 'commons/constants';
import { Circle as CircleIcon } from '@mui/icons-material';

function displayArrService(dataRow = []) {
  if (!dataRow) return '';

  return dataRow?.map((item, index) => (
    <div key={index} style={{ textAlign: 'left' }}>
      <CircleIcon color="primary" sx={{ fontSize: 10, marginRight: '5px' }} />
      {item.name}
    </div>
  ));
}

export const getColumnsPersonal = (
  onChangeSearch,
  deleteItem,
  searchQuotationDate,
  handleChangeSearchQuotationDate,
  searchCustomerResponseDate,
  handleChangeSearchCustomerResponseDate,
  searchStatus,
  handleChangeSearchStatus,
) => [
  {
    id: 'code',
    numeric: true,
    disablePadding: false,
    align: 'center',
    label: <SearchInputColumn title="Mã" name="code" onChange={onChangeSearch} />,
  },
  {
    id: 'clientCompanyName',
    numeric: true,
    disablePadding: false,
    label: (
      <SearchInputColumn title="Khách hàng" name="clientCompanyName" onChange={onChangeSearch} />
    ),
    width: '300px',
    align: 'center',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: (
      <>
        <b>Trạng thái</b>
        <SelectionSearchColumn
          size="small"
          label=""
          name="typeClientCompany"
          dataArrObject={QUOTE_PRICE_STATUS_OPTIONS_ALL}
          value={searchStatus}
          onChange={handleChangeSearchStatus}
          displayNone={false}
        />
      </>
    ),
    align: 'center',
    render: (row) =>
      row?.status || row?.status === 0 ? QUOTE_PRICE_STATUS_OPTIONS_COLUMN[row?.status] : '',
  },
  {
    id: 'quotationDate',
    numeric: true,
    disablePadding: false,
    label: (
      <div>
        <div>Ngày báo giá</div>
        <DatePickerSearchColumn
          sx={{
            marginBottom: '10px',
            padding: 0,
          }}
          width={'140px'}
          marginTop="0"
          size="small"
          onChange={handleChangeSearchQuotationDate}
          value={searchQuotationDate}
          error={true}
          label=""
        />
      </div>
    ),
    align: 'center',
    render: (row) => Utils.formatDateFn(row?.quotationDate),
  },
  {
    id: 'arrService',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Dịch vụ" name="arrService.name" onChange={onChangeSearch} />,
    align: 'center',
    render: (row) => displayArrService(row?.arrService),
  },
  // {
  //   id: 'arrUrlfile',
  //   numeric: true,
  //   disablePadding: false,
  //   label: 'File đính kèm',
  //   align: 'center',
  //   render: (row) => <ShowListFile maxWidth="200px" fileList={row?.arrUrlfile} />,
  // },
  {
    id: 'customerResponseDate',
    numeric: true,
    disablePadding: false,
    label: (
      <div>
        <div>Ngày KH phản hồi</div>
        <DatePickerSearchColumn
          sx={{
            marginBottom: '10px',
            padding: 0,
          }}
          width={'140px'}
          marginTop="0"
          size="small"
          onChange={handleChangeSearchCustomerResponseDate}
          value={searchCustomerResponseDate}
          error={true}
          label=""
        />
      </div>
    ),
    align: 'center',
    render: (row) => Utils.formatDateFn(row?.customerResponseDate),
  },
  {
    id: 'note',
    numeric: true,
    disablePadding: false,
    label: <SearchInputColumn title="Ghi chú" name="note" onChange={onChangeSearch} />,
    align: 'center',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Thao tác',
    width: '10px',
    fixed: 'right',
    align: 'center',
    render: (row) => (
      <Button
        variant="contained"
        size="small"
        color="error"
        sx={{ borderRadius: '15px', textTransform: 'none' }}
        onClick={() => window.showConfirm(() => deleteItem(row))}
      >
        Xoá
      </Button>
    ),
  },
];
